import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createBlock as _createBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
import _imports_0 from '@/assets/images/more.png';
import _imports_1 from '@/assets/images/svg/icon-view-gray.svg';
import _imports_2 from '@/assets/images/svg/icon-reload.svg';

const _withScopeId = n => (_pushScopeId("data-v-66d0c779"), n = n(), _popScopeId(), n);

const _hoisted_1 = {
  class: "featured"
};
const _hoisted_2 = {
  style: {
    "margin-top": "10px"
  }
};
const _hoisted_3 = {
  key: 0,
  class: "video_cont"
};
const _hoisted_4 = {
  class: "item_title"
};
const _hoisted_5 = ["onClick"];

const _hoisted_6 = /*#__PURE__*/_createTextVNode(" 更多");

const _hoisted_7 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: ""
}, null, -1));

const _hoisted_8 = [_hoisted_6, _hoisted_7];
const _hoisted_9 = ["onClick"];
const _hoisted_10 = {
  class: "flex"
};
const _hoisted_11 = {
  class: "btm_btns"
};
const _hoisted_12 = ["onClick"];

const _hoisted_13 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_1,
  alt: ""
}, null, -1));

const _hoisted_14 = /*#__PURE__*/_createTextVNode(" 查看更多 ");

const _hoisted_15 = [_hoisted_13, _hoisted_14];
const _hoisted_16 = ["onClick"];

const _hoisted_17 = /*#__PURE__*/_createTextVNode("换一批 ");

const _hoisted_18 = {
  class: "search_details_page"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_SwipeComponent = _resolveComponent("SwipeComponent");

  const _component_advertise_swipe = _resolveComponent("advertise-swipe");

  const _component_video_item = _resolveComponent("video-item");

  const _component_search_popup = _resolveComponent("search-popup");

  const _component_van_popup = _resolveComponent("van-popup");

  const _component_van_list = _resolveComponent("van-list");

  return _openBlock(), _createBlock(_component_van_list, {
    loading: $setup.loading,
    "onUpdate:loading": _cache[1] || (_cache[1] = $event => $setup.loading = $event),
    error: $setup.error,
    "onUpdate:error": _cache[2] || (_cache[2] = $event => $setup.error = $event),
    finished: $setup.finished,
    "error-text": "请求失败，点击重新加载",
    "finished-text": "-我也是有底线的-",
    "loading-text": "正在获取数据...",
    onLoad: $setup.onLoad
  }, {
    default: _withCtx(() => [_createElementVNode("div", _hoisted_1, [_createVNode(_component_SwipeComponent), _createElementVNode("div", _hoisted_2, [_createVNode(_component_advertise_swipe)]), $setup.videoList.length ? (_openBlock(), _createElementBlock("div", _hoisted_3, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.videoList, (item, index) => {
      return _openBlock(), _createElementBlock("div", {
        class: "video_item",
        key: index + '-' + item.author_id
      }, [_createElementVNode("div", _hoisted_4, [_createTextVNode(_toDisplayString(item.name) + " ", 1), _createElementVNode("div", {
        class: "more",
        onClick: $event => $setup.menuAll(item)
      }, _hoisted_8, 8, _hoisted_5)]), item.rows.length ? (_openBlock(), _createElementBlock("div", {
        key: 0,
        class: "video_item_box",
        onClick: $event => $setup.videoPlay(item.rows[0])
      }, [(_openBlock(), _createBlock(_component_video_item, {
        key: item.rows[0].id,
        dataItem: item.rows[0]
      }, null, 8, ["dataItem"]))], 8, _hoisted_9)) : _createCommentVNode("", true), _createElementVNode("div", _hoisted_10, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.rows.slice(1), elem => {
        return _openBlock(), _createElementBlock("div", {
          class: "video_box",
          key: elem.id
        }, [(_openBlock(), _createBlock(_component_video_item, {
          key: elem.id,
          dataItem: elem
        }, null, 8, ["dataItem"]))]);
      }), 128))]), _createElementVNode("div", _hoisted_11, [_createElementVNode("div", {
        onClick: $event => $setup.menuAll(item)
      }, _hoisted_15, 8, _hoisted_12), _createElementVNode("div", {
        onClick: $event => $setup.videoMore(item)
      }, [_createElementVNode("img", {
        class: _normalizeClass($setup.isMore ? 'is_more' : ''),
        src: _imports_2,
        alt: ""
      }, null, 2), _hoisted_17], 8, _hoisted_16)])]);
    }), 128))])) : _createCommentVNode("", true), _createVNode(_component_van_popup, {
      show: $setup.showDetailsPopul,
      "onUpdate:show": _cache[0] || (_cache[0] = $event => $setup.showDetailsPopul = $event),
      class: "popup_coentent",
      teleport: "#app",
      overlay: false,
      position: "right"
    }, {
      default: _withCtx(() => [_createElementVNode("div", _hoisted_18, [(_openBlock(), _createBlock(_component_search_popup, {
        searchText: $setup.menuTetx,
        menu_id: $setup.menu_id,
        label_id: '',
        key: $setup.menu_id,
        onClose: $setup.close
      }, null, 8, ["searchText", "menu_id", "onClose"]))])]),
      _: 1
    }, 8, ["show"])])]),
    _: 1
  }, 8, ["loading", "error", "finished", "onLoad"]);
}